/***
 * Created on 2025/5/12
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import {useTranslation} from "react-i18next";
import ModalAlertComponent from "../common/ModalComonent/ModalAlertComponent";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useOrganizationApi} from "../../hook/OrganizationAPIHook";
import {useOrganization} from "../../context/OrganizationContext";
import {invalidateAccessGrant} from "../../service/accessGrantSync";
import {useAlertContext} from "../../context/AlertContext";

function CloudSpaceRemoveLimitUserWarningDialog({isOpen, onClose, state, dispatch}) {
    const { t } = useTranslation();
    const {OrganizationAPI} = useOrganizationApi();
    const {getCurrentOrg} = useOrganization();
    const currentUser = JSON.parse(window.localStorage.getItem('currentUser'));
    const org = getCurrentOrg();
    const queryClient = useQueryClient();
    const alert = useAlertContext();

    const deleteMutation = useMutation({
        mutationFn: async (data) => await OrganizationAPI.q2.put(`org_storage/${org.organization_id}/space_limit`, {}, data),
        onSuccess: async (data, variables) => {
            console.log('Remove user from unrestricted list success', data);
            const activity_data = {
                organization_id: org.organization_id,
                user_id: currentUser.user_id,
                event: 26,
                category: 6,
                meta_data: {data: variables}
            }
            await OrganizationAPI.put('organization_activity',null, activity_data);
            dispatch({type: 'select_none'});
            onClose();
            alert(true, 'success', 0, t('@User removed from the Unrestricted storage list successfully.@'), 10000);
            invalidateAccessGrant(queryClient, org.organization_id);
        },
        onError: (error) => {
            console.log('Remove user from unrestricted list error', error);
            onClose();
            alert(true, 'error', error?.code, 'Failed to remove user from the Unrestricted storage list. Please try again later.');
        }
    });

    const onConfirmAction = async () => {
        console.log(state.remove_unrestricted_user, state.data);
        const selected = state?.remove_unrestricted_user?.map((item) => item.user_id);
        const selected_data = state.data.filter(item=>!selected.includes(item.user_id)).map((item) => ({user_id: item.user_id, qid: item.email}));
        const selected_ids = selected_data.map((item) => item.user_id);
        const removed_data = state.data.filter(item=>selected.includes(item.user_id)).map((item) => ({user_id: item.user_id, qid: item.email}));
        const data = {
            exception_user_ids: selected_ids,
            ignore_warning: true,
            personal_max_size: state.usage_data.personal_max_size,
            removed_data
        }
        await deleteMutation.mutateAsync(data);
    }

    return (
        <ModalAlertComponent isOpen={isOpen} onClose={onClose} onConfirmAction={onConfirmAction}>
            <div className="alert-msg-inner-head">{t('@Remove User from Unrestricted List@')}</div>
            <div>
                <div className="text-wrap">
                    {t('@Are you sure you want to remove the selected user(s) from the unrestricted list? Their storage usage will now be limited according to the set quota.@')}
                </div>
            </div>
        </ModalAlertComponent>
    );
}

export default CloudSpaceRemoveLimitUserWarningDialog;